export default __webpack_public_path__ + "static/media/check.40e72d96.svg";